import { globalError, TYPE_ERROR } from 'app/shared/error/error-global';
import { accountApi } from '../api';
import { formatDate } from 'app/shared/util/date-utils';
import { IFirstCustomer } from 'app/modules/firstCustomer/model/firstCustomer.model';
import { mapCivility } from 'app/shared/util/method-util';
import { ACTION_TYPES as FIRST_CUSTOMER_ACTIONS } from 'app/modules/firstCustomer/service/store/firstCustomer.actions';
import { ACTION_TYPES as CUSTOMER_ACTIONS } from 'app/modules/customer/service/store/customer.actions';

export const getAuthorizeUrl = () => {
  return async (): Promise<string | undefined> => {
    const result: any = await accountApi.getAuthorizeUrl();

    if (result.isFailure) {
      globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() });
      return undefined;
    }
    console.log("getAuthorizeUrl", result, result.getValue())

    return result.getValue(); // Promise<string>
  };
};

export const handleLogin = () => async dispatch => {
  const url = await dispatch(getAuthorizeUrl());

  console.log("handleLogin", url)
  if (url) {
    window.location.href = url;
  }
};

// Fonction de transformation des données API vers IFirstCustomer
const transformApiDataToCustomer = (apiData: any): Partial<IFirstCustomer> => {

  return {
    externalRef: apiData?.CustomerGuid,
    civility: mapCivility(apiData?.Civility),
    lastName: apiData?.LastName,
    firstName: apiData?.FirstName,
    email: apiData?.Email,
    phoneNumber: apiData?.MobilePhoneNumber,
    birthday: apiData?.Birthdate ? formatDate(apiData.Birthdate) : undefined,
    // cityOfBirth: apiData.BirthDepartment, 
    address: apiData.Address?.AddressLine1,
    zipCode: apiData.Address?.ZipCode,
    city: apiData.Address?.City,
    country: apiData.Address?.Country,
  };
};

export async function getCustomer(code: string, dispatch): Promise<any> {

  try {

    const response = await accountApi.getCustomer(code);
    const data = response.getValue();

    if (response.isFailure) {
      throw new Error("Code expiré : " + code);
    }

    dispatch({
      type: FIRST_CUSTOMER_ACTIONS.UPDATE_CUSTOMER,
      payload: transformApiDataToCustomer(data)
    });

    dispatch({
      type: CUSTOMER_ACTIONS.UPDATE_CUSTOMER,
      payload: transformApiDataToCustomer(data)
    });

    return data;
  } catch (err) {
    console.error("Erreur getCustomer", err);
    throw err;
  }
}
